import { addEvent, removeEvent, updateEvent, EVENT_TYPES } from '../model/events';

export default function EventsPanel({ events, onChange }) {
  const list = events || [];

  const handleAdd = () => onChange(addEvent(list));
  const handleRemove = (index) => onChange(removeEvent(list, index));
  const handleUpdate = (index, patch) => onChange(updateEvent(list, index, patch));

  return (
    <section className="chart-card economics-panel">
      <h2>Step events</h2>
      <p className="chart-hint">
        One-time shocks by month — signup delta, MRR shock, conversion shift (pp), or cash injection.
      </p>

      <button type="button" className="secondary-button" onClick={handleAdd}>
        Add event
      </button>

      {list.length === 0 && (
        <p className="economics-muted">No events configured. Add a launch, campaign, or pricing change.</p>
      )}

      {list.map((ev, index) => (
        <div key={index} className="forecast-event-row">
          <div className="economics-form-grid economics-form-grid-3">
            <label className="economics-field">
              <span>Month</span>
              <input
                type="number"
                min="0"
                max="60"
                value={ev.monthIndex}
                onChange={(e) =>
                  handleUpdate(index, {
                    monthIndex: Math.min(60, Math.max(0, parseInt(e.target.value, 10) || 0)),
                  })
                }
              />
            </label>
            <label className="economics-field">
              <span>Type</span>
              <select
                value={ev.type}
                onChange={(e) => handleUpdate(index, { type: e.target.value })}
              >
                {EVENT_TYPES.map((t) => (
                  <option key={t.value} value={t.value}>
                    {t.label}
                  </option>
                ))}
              </select>
            </label>
            <label className="economics-field">
              <span>Label</span>
              <input
                type="text"
                value={ev.label}
                onChange={(e) => handleUpdate(index, { label: e.target.value })}
              />
            </label>
            {ev.type !== 'cash_injection' && ev.type !== 'churn' ? (
              <label className="economics-field">
                <span>Δ signups</span>
                <input
                  type="number"
                  value={ev.deltaSignups ?? 0}
                  onChange={(e) =>
                    handleUpdate(index, { deltaSignups: parseFloat(e.target.value) || 0 })
                  }
                />
              </label>
            ) : null}
            {ev.type === 'cash_injection' ? (
              <label className="economics-field">
                <span>Cash amount ($)</span>
                <input
                  type="number"
                  min="0"
                  value={ev.amount ?? 0}
                  onChange={(e) =>
                    handleUpdate(index, {
                      amount: Math.max(0, parseFloat(e.target.value) || 0),
                    })
                  }
                />
              </label>
            ) : ev.type === 'churn' ? (
              <>
                <label className="economics-field">
                  <span>Churn Δ (pp)</span>
                  <input
                    type="number"
                    min="-100"
                    max="100"
                    step="0.1"
                    value={ev.churnDeltaPp ?? 0}
                    onChange={(e) =>
                      handleUpdate(index, {
                        churnDeltaPp: Math.min(
                          100,
                          Math.max(-100, parseFloat(e.target.value) || 0)
                        ),
                      })
                    }
                  />
                </label>
              </>
            ) : (
              <>
                <label className="economics-field">
                  <span>MRR shock ($)</span>
                  <input
                    type="number"
                    value={ev.mrrShock ?? 0}
                    onChange={(e) =>
                      handleUpdate(index, { mrrShock: parseFloat(e.target.value) || 0 })
                    }
                  />
                </label>
                <label className="economics-field">
                  <span>Paid-stage Δ (pp)</span>
                  <input
                    type="number"
                    min="-100"
                    max="100"
                    step="0.1"
                    value={ev.conversionDeltaPp ?? 0}
                    onChange={(e) =>
                      handleUpdate(index, {
                        conversionDeltaPp: Math.min(
                          100,
                          Math.max(-100, parseFloat(e.target.value) || 0)
                        ),
                      })
                    }
                  />
                </label>
              </>
            )}
          </div>
          <button type="button" className="secondary-button" onClick={() => handleRemove(index)}>
            Remove
          </button>
        </div>
      ))}
    </section>
  );
}
